import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const VideoPlayer = ({ videoName }) => {
	const videoRef = useRef(null);

	const videoUrl = `https://${
		process.env.REACT_APP_API_URL
	}/landingpage/get-chunk?filename=${videoName?.src}`;

	useEffect(
		() => {
			let hls;
			if (Hls.isSupported()) {
				let bearerToken = sessionStorage.getItem('adal.idtoken');
				hls = new Hls({
					xhrSetup: (xhr, url) => {
						const modifiedUrl = url.includes('get-chunk')
							? url
							: url.replace('landingpage/', 'landingpage/get-chunk?filename=');

						xhr.open('GET', modifiedUrl, true);

						if (bearerToken) {
							xhr.setRequestHeader('Authorization', `Bearer ${bearerToken}`);
						} else {
							console.log('No Bearer token available');
						}
					},
				});

				hls.loadSource(videoUrl);
				hls.attachMedia(videoRef.current);

				return () => {
					hls.destroy();
				};
			} else if (
				videoRef.current.canPlayType('application/vnd.apple.mpegurl')
			) {
				videoRef.current.src = videoUrl;
			}
		},
		[videoUrl]
	);

	return (
		<div style={{ display: 'flex', justifyContent: 'center' }}>
			<video ref={videoRef} controls width="100%" height="auto" autoPlay />
		</div>
	);
};

export default VideoPlayer;
